import React, {useState, useEffect, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {temperatureUnitItem} from '../../../App';
import MenuContext from '../../../context/menuContext';
import ConfigContext from '../../../context/configContext';
import DensityUnit from './density-unit';
import ChannelConfig from './channel-config';

function TemperatureUnit({onExit}) {
  const {onComponent, setDisableMenu} = useContext(MenuContext);
  const {config, onUpdate} = useContext(ConfigContext);
  const leftPress = useKeyPress('ArrowLeft');

  useEffect(() => {
    if (!leftPress) return;

    onComponent(<DensityUnit />);
  }, [leftPress]);

  const onRight = selected => {
    onUpdate('temperature', {...config.temperature, unit: selected.name});
    // setDisableMenu(false);
    onComponent(<ChannelConfig />);
  };

  return (
    <FullBodyMenuView
      title="Select Temperature Unit"
      menuItems={temperatureUnitItem}
      initialSelected={config.temperature.unit}
      onRightCallback={onRight}
    />
  );
}
export default TemperatureUnit;
